import { createContext, useContext } from "react";
import { IHookNotificationPortal } from "../model/inteface.notificationPortal";

export const NotificationPortalContext = createContext<IHookNotificationPortal | null>(
  null
);

export const useNotificationPortal = (): IHookNotificationPortal => {
  const ctx = useContext(NotificationPortalContext);
  if (!ctx) {
    const message = "useNotificationPortal deve ser usado dentro do Provider";
    throw new Error(message);
  }
  return ctx;
};
